import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-6 sm:py-8 bg-slate-900 text-slate-400" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_cf89158a-bcc4-4183-9507-642ba4ecfd15/artifacts/wcokteot_rt.png" 
              alt="Kaufmanns Consulting"
              className="h-6 sm:h-8 w-auto"
            />
          </div>
          <p className="text-xs sm:text-sm text-center sm:text-right">
            © {currentYear} Kaufmanns Consulting. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};
